import { I as t } from "../../iconLoader.gen-BAA9zfPt.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
